import React, { useEffect, useState } from 'react';
import { useLoginMutation } from '../../../redux/api/driverApi'
import { Link, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';
import MetaData from '../../layout/MetaData'

const DriverLogin = () => {
    const navigate = useNavigate();
    const [phoneNo, setPhoneNo] = useState("");
    const [password, setPassword] = useState("");

    const [login, { isLoading, error, data }] = useLoginMutation();
    const { isAuthenticated } = useSelector((state) => state.auth);

    useEffect(() => {
        if (isAuthenticated) {
            navigate("/");
            toast.success("آپ پہلے ہی لاگ ان ہیں۔");
        }
        if (error) {
            const errorMessage = error?.data?.message;
            console.log("Error Message:", errorMessage);
            
            if (errorMessage?.toLowerCase().includes("not verified")) {
                navigate("/driver/verify-phone");
                toast.error("THE ENTERED PHONE NUMBER IS NOT VERIFIED. A verification code is sent to your whatsapp, Pls verify your Number")
            } else {
                toast.error(errorMessage);
            }
        }
    }, [error, isAuthenticated, navigate]);

    const submitHandler = (e) => {
        e.preventDefault();
        const loginData = { phoneNo, password };
        login(loginData);
    };

    return (
        <>
            <MetaData title={'Driver Login'} />
            <div className="row wrapper">
                <div className="col-10 col-lg-5">
                    <form className="shadow rounded bg-body" onSubmit={submitHandler}>
                        <h2 className="mb-4">لاگ ان</h2>
                        <div className="mb-3">
                            <label htmlFor="phoneNo_field" className="form-label">
                                <h3>فون نمبر</h3>
                            </label>
                            <input
                                type="text"
                                id="phoneNo_field"
                                className="form-control"
                                onChange={(e) => setPhoneNo(e.target.value)}
                            />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="password_field" className="form-label">
                                <h3>پاسورڈ</h3>
                            </label>
                            <input
                                type="password"
                                id="password_field"
                                className="form-control"
                                name="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                        </div>
                        <button id="login_button" type="submit" className="btn w-100 py-2" disabled={isLoading}>
                            <h4>{isLoading ? "Authenticating..." : "لاگ ان"}</h4>
                        </button>
                        <div className="my-3">
                            <Link to="/register">Register</Link>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
};

export default DriverLogin;
